import React from 'react'
import Navbar from '../inc/Navbar'
import Durgapuja2025 from './Durgapuja2025'
import {Link} from "react-router-dom";
 

function Durgapuja() {
  return (
    <div>
        <Navbar/>
        <br/>
        <br/>
        <br/>
        <br/>
        <div className='garmentkarimpur'>
        <div className="album py-1">
                <div className="container mt-4">
                  <div className="row">
                    <nav aria-label="breadcrumb">
                      <ol className="breadcrumb">
                        <li style={{ color: "maroon" }} className="breadcrumb-item"><Link style={{ color: "maroon" }} to="/" > Home</Link></li>
                     
        
                        <li style={{ color: "maroon" }} className="breadcrumb-item"><Link style={{ color: "maroon" }} to="/contact" href="#">Contact</Link></li>
                        <li className="breadcrumb-item active" aria-current="page">Durga Puja Collection 2025</li>
        
                      </ol>
                    </nav>
                  </div>
                </div>
                </div>
              </div>
        <Durgapuja2025/>
        <br/>
    </div>
  )
}

export default Durgapuja